import { SpacingInputUnit } from './enums'

export enum SpacingInputPosition {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
}

export type SpacingInputValue = Record<
  SpacingInputPosition,
  {
    value: number
    unit: SpacingInputUnit
  }
>
